import React, { useState, useContext } from 'react';
import { TranslationContext, SettingsContext } from './Context';

const BuyArea = props => {
    const translations = useContext(TranslationContext);
    const settings = useContext(SettingsContext);

    const inventory = settings.skudata.price?.commerceData?.inventory ? settings.skudata.price.commerceData.inventory : 0;
    const multiple = settings.skudata.price?.commerceData?.multiple ? settings.skudata.price.commerceData.multiple : 1;
    const [quantity, setQuantity] = useState(multiple);

    var displayLowStockVerbiage = inventory < 51 && settings.skudata.price.commerceData?.status == "Out of Production";

    const increaseQuantity = () => {
        setQuantity(quantity + multiple);
    };

    const decreaseQuantity = () => {
        if (quantity > 1) {
            setQuantity(quantity - multiple);
        }
    };

    const callAddToCart = () => {
        props.addToCart(settings.skudata.skuNumber, settings.skudata.name, settings.skudata.skuId, settings.skudata.originalSkuNumber, settings.skudata.modelId, quantity, true, settings.skudata.category, settings.skudata.priceUnformatted);
        setQuantity(multiple);
    };

    return (
        <div className="variantPickerComponent-buyArea">
            {
                settings.renderb2bbuyarea && settings.skudata.price && settings.skudata.price?.commerceData?.givenPrice &&
                <div className="variantPickerComponent-buyAreaInner">
                    <div className="u-textSemi24 u-textWhite variantPickerComponent-price">
                        {settings.skudata.price.commerceData.msrpPrice && settings.skudata.price.commerceData.msrpPrice !== settings.skudata.price.commerceData.givenPrice && <div className="variantPickerComponent-priceMsrp">{translations["VariantPicker.MSRP"]} {settings.skudata.price.commerceData.msrpPrice}</div>}
                        {settings.skudata.price.commerceData.givenPrice}
                    </div>

                    {
                        settings.renderAddToCart &&
                        <div className="variantPickerComponent-quantityArea">
                            <div className="u-spinButton">
                                <div className="u-spinButton-number">
                                            <input className="form-control qty u-spinButton-numberInput" type="text" disabled={!settings.skudata.price.commerceData.buyable} min={multiple} step={multiple} max={displayLowStockVerbiage?settings.skudata.price?.commerceData?.inventory:1000} value={quantity} required />
                                </div>
                                <div className="u-spinButton-quantityWrapper">
                                    <button className="plus u-spinButton-btn" type="button" disabled={!settings.skudata.price.commerceData.buyable} onClick={increaseQuantity}>+</button>
                                    <button className="min u-spinButton-btn" type="button" disabled={!settings.skudata.price.commerceData.buyable} onClick={decreaseQuantity}>&ndash;</button>
                                </div>
                            </div>

                            <button onClick={callAddToCart} type="button" disabled={!settings.skudata.price.commerceData.buyable} className="btn btn-primary variantPickerComponent-btnBuy">{translations["VariantPicker.AddToCart"]}</button>
                        </div>
                    }
                </div>
            }

            <div className="variantPickerComponent-buyAreaMeta">
                <span className="variantPickerComponent-buyAreaMetaArtnr">{translations["VariantPicker.ArticleNumber"]}</span> {settings.skudata.skuNumber} {settings.skudata.legacyItemNumber && <span>({settings.skudata.legacyItemNumber})</span>}
                <br />
                {
                    settings.renderb2bbuyarea &&
                    <span className="u-mtop5 u-textRegular10 u-textWhite">{settings.skudata.price?.commerceData?.stockText}</span>
                }
                {   displayLowStockVerbiage &&
                    <div class="lowstockverbiage u-dFlex u-floatright">
                        <div><svg height="8" width="8" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 8"><circle cx="4.5" cy="4" r="4" fill="#F89D4A"></circle></svg>
                        </div>
                        <div>|</div>
                        <div>{translations["LowInventoryVerbiage"]}</div>
                    </div>
                }
            </div>
        </div>
    );
};

export default BuyArea;